import { createSlice } from '@reduxjs/toolkit';
import { statusTypes } from '@/constants/types';
import { fetchPlaceOrderDetails } from '../thunk/place-order-thunk';

// is used to show success place order and invoice details
const initialState = {
  placeOrderDetails: {},
  placeOrderItems: [],
  fetchOrderDetailsInformationStatus: statusTypes.idle,
  paymentDetails: null,
  orderAddress: null,
  shippingMethodInfo: null,
  error: '',
};

const placeOrderSlice = createSlice({
  name: 'placeOrder',
  initialState,
  reducers: {
    // reset state when checkout button click in cart page or logout
    resetPlaceOrderStateForNextCheckout: () => ({
      ...initialState,
    }),
    resetPlaceOrderForCache() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlaceOrderDetails.pending, (state) => {
        state.fetchOrderDetailsInformationStatus = statusTypes.loading;
        state.error = null;
      })
      .addCase(fetchPlaceOrderDetails.fulfilled, (state, action) => {
        const { data } = action.payload;

        state.fetchOrderDetailsInformationStatus = statusTypes.succeeded;
        state.placeOrderDetails = data;
        state.paymentDetails =
          data?.payments.length > 0 ? data?.payments?.[0] : null;
        state.orderAddress = data?.order_address;
        state.placeOrderItems = data?.order_items;
        state.shippingMethodInfo = {
          method: data?.shipping_method,
          shopCode: data?.shop_code || null,
        };
        state.error = '';
      })
      .addCase(fetchPlaceOrderDetails.rejected, (state, action) => {
        const { data } = action.payload;

        state.fetchOrderDetailsInformationStatus = statusTypes.failed;
        state.error =
          data?.error?.message || 'Failed to get place order details';
      });
  },
});

export const { resetPlaceOrderStateForNextCheckout, resetPlaceOrderForCache } =
  placeOrderSlice.actions;

export default placeOrderSlice.reducer;
